"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
const GroupKeyMessage_1 = __importDefault(require("./GroupKeyMessage"));
const StreamMessage_1 = __importStar(require("./StreamMessage"));
const utils_1 = require("@streamr/utils");
class GroupKeyRequest extends GroupKeyMessage_1.default {
    constructor({ requestId, recipient, rsaPublicKey, groupKeyIds }) {
        super(recipient, StreamMessage_1.default.MESSAGE_TYPES.GROUP_KEY_REQUEST);
        (0, validations_1.validateIsString)('requestId', requestId);
        this.requestId = requestId;
        (0, validations_1.validateIsString)('rsaPublicKey', rsaPublicKey);
        this.rsaPublicKey = rsaPublicKey;
        (0, validations_1.validateIsArray)('groupKeyIds', groupKeyIds);
        this.groupKeyIds = groupKeyIds;
    }
    toArray() {
        return [this.requestId, this.recipient, this.rsaPublicKey, this.groupKeyIds];
    }
    static fromArray(args) {
        const [requestId, recipient, rsaPublicKey, groupKeyIds] = args;
        return new GroupKeyRequest({
            requestId,
            recipient: (0, utils_1.toEthereumAddress)(recipient),
            rsaPublicKey,
            groupKeyIds,
        });
    }
    static is(streamMessage) {
        return streamMessage.messageType === StreamMessage_1.StreamMessageType.GROUP_KEY_REQUEST;
    }
}
exports.default = GroupKeyRequest;
GroupKeyMessage_1.default.classByMessageType[StreamMessage_1.StreamMessageType.GROUP_KEY_REQUEST] = GroupKeyRequest;
//# sourceMappingURL=GroupKeyRequest.js.map